import { render, staticRenderFns } from "./Responsibility.vue?vue&type=template&id=251b0124&scoped=true"
import script from "./Responsibility.vue?vue&type=script&lang=js"
export * from "./Responsibility.vue?vue&type=script&lang=js"
import style0 from "./Responsibility.vue?vue&type=style&index=0&id=251b0124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251b0124",
  null
  
)

export default component.exports